import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material'
import { CloseIcon } from '@/icons'
import { CommonButton } from './CommonButton'

export const CommonDialog = ({
  open,
  onClose,
  title,
  actions,
  children,
  titleAction,
  closable = true,
  persistent = true,
  ...dialogProps
}) => {
  const handleDialogClose = (event, reason) => {
    if (
      persistent &&
      (reason === 'escapeKeyDown' || reason === 'backdropClick')
    )
      return
    onClose()
  }

  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      className={!open ? 'inert' : ''}
      onClick={event => event.stopPropagation()}
      {...dialogProps}
    >
      {title && (
        <DialogTitle sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          {title}
          {titleAction && titleAction}
          {closable && (
            <CommonButton
              aria-label='close'
              onClick={onClose}
              variant='text'
              size='small'
              iconOnly={<CloseIcon />}
              style={{ position: 'absolute', right: 8, top: 8 }}
            />
          )}
        </DialogTitle>
      )}
      {!title && closable && (
        <CommonButton
          aria-label='close'
          onClick={onClose}
          style={{ position: 'absolute', right: 0, top: 0 }}
          variant='text'
          size='small'
          iconOnly={<CloseIcon />}
        />
      )}
      <DialogContent>{children}</DialogContent>
      {actions && (
        <DialogActions style={{ alignItems: 'end', padding: '16px 24px' }}>
          {actions}
        </DialogActions>
      )}
    </Dialog>
  )
}
